import React from 'react';
import { PapiDeviation, RelatedBlock } from '@wix/da-papi-types';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import CollectionBlock from './CollectionBlock';
import s from './Collections.scss';

interface Props {
  block: RelatedBlock;
  deviation: PapiDeviation;
}

const Collections: React.FC<React.PropsWithChildren<Props>> = ({
  block,
  deviation: parentDeviation,
}) => {
  return (
    <SidebarBlockWrapper deviation={parentDeviation} block={block} headerClassName={s['header']}>
      <div>
        {block.collections?.map(
          ({ collection, deviations }) =>
            collection &&
            deviations && (
              <CollectionBlock
                key={collection.folderId}
                parentDeviation={parentDeviation}
                collection={collection}
                deviations={deviations}
              />
            )
        )}
      </div>
    </SidebarBlockWrapper>
  );
};
Collections.displayName = 'Collections';

export default Collections;
